import { useCallback, useEffect, useState } from 'react'
import { StoreInterface } from '../../../../common/types/interfaces'
import { getSalesApi } from '../../../../salesApi/salesApi'
import { selectCurrentCluster } from '../../../../store/slices/currentClusterSlice'
import { useSelector } from 'react-redux'
import { schedulePattern } from '../../../../common/utils/constants'

const initialValue: StoreInterface = {
  name: '',
  description: '',
  files: [],
  city: { value: '', latitude: '', longitude: '' },
  address: { value: '', latitude: '', longitude: '' },
  type: '',
  phone_number: '',
  schedule: [...schedulePattern],
  isActive: true,
  temporarilyDisabled: false,
   deliveryRadius: '',
  withDelivery: false,
  sortOrder: 0
}

export const useStore = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [detailsModalActive, setDetailsModalActive] = useState<boolean>(false)
  const [edit, setEdit] = useState<boolean>(false)
  const [salesApi] = useState(getSalesApi())
  const [data, setData] = useState<StoreInterface>(structuredClone(initialValue))
  const [list, setList] = useState<StoreInterface[]>([])
  const [current, setCurrent] = useState<StoreInterface>()
  const currentCluster = useSelector(selectCurrentCluster)
  const [loading, setLoading] = useState(true)

  const getList = useCallback(async () => {
    try {
      const result = await salesApi.getStoreList({all:true})
      setLoading(false)
      if (result) setList(result.data)
    } catch (error) {
      setLoading(false)
    }
  }, [salesApi])

  const startCreate = (qr?: string) => {
    setCurrent(undefined)
    setData((prev) => ({ ...prev, barCode: qr }))
    setModalActive(true)
  }
  const startEdit = (el: StoreInterface) => {
    setCurrent({ ...el })
    setEdit(true)
    setModalActive(true)
  }

  const showDetails = useCallback((el: StoreInterface) => {
    setCurrent(el)
    setDetailsModalActive(true)
  }, [])

  useEffect(() => {
    if (currentCluster) getList()
  }, [currentCluster, getList])

  useEffect(() => {
    if (!modalActive) setData(initialValue)
  }, [modalActive])

  return {
    getList,
    modalActive,
    setModalActive,
    startCreate,
    startEdit,
    edit,
    data,
    setData,
    list,
    detailsModalActive,
    setDetailsModalActive,
    showDetails,
    current,
    loading
  }
}
